import { AxiosResponse } from "axios";
import EventClusterRemoveDTO from "../../models/EventClusterRemoveDTO";
import apiRequest from "../../utils/apiUtils/apiRequest";
import courseApiRequest from "../../utils/apiUtils/courseApiRequest";


export function getAllEvents() {
    const url = "/events/all";
    return apiRequest.get(url).then((response: AxiosResponse) => {
        return response;
    });
}

export function deleteEvent(updatedBy: string, id?: number, doNotSendEmail?: boolean) {
    const url = "/events/remove";
    let eventToRemove = new EventClusterRemoveDTO();
    eventToRemove.clusterId = id;
    eventToRemove.updatedBy = updatedBy;
    eventToRemove.doNotSendEmail = doNotSendEmail;
    return courseApiRequest.post(url, eventToRemove).then((response: AxiosResponse) => {
        return response;
    });
}

export function cancelRemoveAction(updatedBy: string, id?: number) {
    const url = "/events/cancelRemoveAction";
    let eventToCancelRemove = new EventClusterRemoveDTO();
    eventToCancelRemove.clusterId = id;
    eventToCancelRemove.updatedBy = updatedBy;
    return courseApiRequest.post(url, eventToCancelRemove).then((response: AxiosResponse) => {
        return response;
    });
}

export function fullOrNotFullEvent(isFull: boolean, id?: number) {
    const url = "/events/full-or-not-full-event";
    let eventToCancelRemove = new EventClusterRemoveDTO();
    eventToCancelRemove.clusterId = id;
    eventToCancelRemove.isFull = isFull;
    return courseApiRequest.post(url, eventToCancelRemove).then((response: AxiosResponse) => {
        return response;
    });
}

export function getEvent(id?: number) {
    const url = "/events/get/" + id;
    return apiRequest.get(url).then((response: AxiosResponse) => {
        return response;
    });
}

